import {MANAGE_SITE_URL} from "gatsby-env-variables-fork";

export function getUserEntryPointUrl(isAuthorizedUser: boolean) {
    return isAuthorizedUser ? `${MANAGE_SITE_URL}/Lectures/Create?type=0` : `${MANAGE_SITE_URL}/Account/Register`;
}